import { createI18n } from 'vue-i18n';

import en from './en.json';
import hr from './hr.json';

export default createI18n({
    legacy: false,
    locale: 'en',
    messages: { en, hr }
});